import { faCalendarExclamation } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Card } from '@/components/ui/card.component';
import { Icon } from '@/components/ui/icon.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { Typography } from '@/components/ui/typography/typography.component';
import { Button } from '@/components/ui/button/button.component';
import { styleFaq } from '@/app/(main)/(pages)/(institucional)/preciso-de-ajuda/_consts/style-faq.consts';
import { handleOpenSearchModal } from '@/store/search/handle-open-search-modal';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

export const FaqWantToScheduleCard = () => {
  const { titleIcon, titleTypography, buttonSmFit } = styleFaq();

  return (
    <Card
      className="p-5 flex flex-col sm:flex-row gap-1 justify-between"
      data-testid={DataTestIdEnum.FAQ_PATIENT_WANT_TO_SCHEDULE_CARD}
    >
      <div className="flex flex-col gap-1">
        <div className="inline-flex">
          <Icon
            className={titleIcon()}
            icon={faCalendarExclamation}
            size="lg"
          />
          <Typography
            className={titleTypography()}
            variant={TypographyVariant.MEDIUM_SUBTITLE}
          >
            Quero agendar
          </Typography>
        </div>
        <Typography>Agende facilmente sua consulta e exames!</Typography>
      </div>

      <Button
        data-testid={DataTestIdEnum.FAQ_PATIENT_CTA_SCHEDULE_BUTTON}
        className={buttonSmFit({ className: 'px-24' })}
        variant="secondary"
        onClick={() => handleOpenSearchModal()}
        data-analytics-event={AnalyticsEnum.CLICK_FAQ_SCHEDULE_BUTTON}
      >
        Agendar
      </Button>
    </Card>
  );
};
